import { render, staticRenderFns } from "./AnalysisBasic.vue?vue&type=template&id=6f144220&scoped=true"
import script from "./AnalysisBasic.vue?vue&type=script&lang=js"
export * from "./AnalysisBasic.vue?vue&type=script&lang=js"
import style0 from "./AnalysisBasic.vue?vue&type=style&index=0&id=6f144220&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f144220",
  null
  
)

export default component.exports